import { VgApiResult, vgApiRequest } from "./vg-api.service";

export type MemberDetail = {
  userId: number;
  orgId: number;
  contactFirstName?: string;
  contactLastName?: string;
  emailAddress?: string;
};

function pickMember(data: Record<string, unknown> | null | undefined): Partial<MemberDetail> {
  if (!data) return {};
  const contact = (data.contactList as any[])?.[0] ?? {};
  return {
    userId: Number(data.userId ?? data.UserId ?? data.memberId ?? data.MemberId ?? 0),
    orgId: Number(data.orgId ?? data.OrgId ?? 0),
    contactFirstName:
      (contact.contactFirstName ?? data.contactFirstName) != null
        ? String(contact.contactFirstName ?? data.contactFirstName)
        : undefined,
    contactLastName:
      (contact.contactLastName ?? data.contactLastName) != null
        ? String(contact.contactLastName ?? data.contactLastName)
        : undefined,
    emailAddress:
      (contact.emailAddress ?? data.emailAddress) != null
        ? String(contact.emailAddress ?? data.emailAddress)
        : undefined,
  };
}

export async function createOrgMember(
  accessToken: string,
  payload: {
    orgId: number;
    contactFirstName: string;
    contactLastName: string;
    emailAddress: string;
  }
): Promise<VgApiResult<{ newRecordID?: number; NewRecordID?: number }>> {
  return vgApiRequest(accessToken, "Create_Member", {
    orgId: payload.orgId,
    contactFirstName: payload.contactFirstName,
    contactLastName: payload.contactLastName,
    emailAddress: payload.emailAddress,
  });
}

export async function readMember(
  accessToken: string,
  orgId: number,
  userId: number
): Promise<VgApiResult<MemberDetail>> {
  const { data, error } = await vgApiRequest<Record<string, unknown>>(accessToken, "Read_Member", {
    orgId,
    userId,
  });
  if (error) return { data: null, error };
  const p = pickMember(data);
  const fullName = data?.name != null ? String(data.name) : "";
  const parts = fullName.trim().split(/\s+/);
  const firstFromName = parts[0] ?? "";
  const lastFromName = parts.slice(1).join(" ") ?? "";
  return {
    data: {
      userId: p.userId ?? userId,
      orgId: p.orgId ?? orgId,
      contactFirstName: p.contactFirstName ?? firstFromName,
      contactLastName: p.contactLastName ?? lastFromName,
      emailAddress: p.emailAddress ?? (data?.emailAddress != null ? String(data.emailAddress) : undefined),
    },
    error: null,
  };
}

export async function deleteOrgMember(
  accessToken: string,
  orgId: number,
  userId: number
): Promise<VgApiResult<unknown>> {
  return vgApiRequest(accessToken, "Delete_Member", { orgId, userId });
}
